module.exports = __webpack_public_path__ + "img/txt_zodiac.a141aee4.png";